import React from 'react';
import { Button } from 'carbon-components-react';
import Dialog from '@material-ui/core/Dialog';
import Slide from '@material-ui/core/Slide';
import Typography from '@material-ui/core/Typography';
import FormCustom from './FormCustom';
import styles from './style';
import { postTempConfigFile } from '../../../../actions/index';
import funcTranslateHelper from '../../../../i18next/funcTranslateHelper';

const Transition = React.forwardRef(function Transition (props, ref) {
  return <Slide direction='down' ref={ref} {...props} />;
});

function NewStageForm (props) {
  const classes = styles();
  const { handleClose, open, setConfigFile, configFile, setOpenNotication, stage } = props;

  const formData = () => {
    if (stage) {
      const rootSatge = stage.name;
      const subStage = stage.stages.map(e => e.name);
      return { name: rootSatge, stages: subStage };
    } else {
      return {};
    }
  };

  async function process (formData) {
    const formDataProcessed = [];

    // proceso de los datos del formulario
    formData.forEach(value => {
      if (Array.isArray(value)) {
        // obtenemos los nombres de los subStages
        value.forEach(e => {
          formDataProcessed.push(e);
        });
      } else {
        // obtenemos el nombre del stage
        formDataProcessed.push(value);
      }
    });

    // si hay stage quiere decir que se va editar el stage de lo contrario se va a agregar uno nuevo
    if (stage) {
      // iteramos sobre todos los stage del configfile
      const newStages = configFile.stages.map(element => {
        // buscamos el stage que se va a editar
        if (element.id === stage.id) {
          // el index 0 es para el root del stage los demas son subStages
          formDataProcessed.forEach((value, index) => {
            if (index === 0) {
              element.name = value;
            } else {
              if (element.stages[index - 1] === undefined) {
                element.stages[index - 1] = { id: value + index, name: value };
              } else {
                element.stages[index - 1].name = value;
              }
            }
          });
          // Quitamos los substages eliminados son subStages
          element.stages = element.stages.slice(0, formDataProcessed.length - 1);
          return element;
        } else {
          return element;
        }
      });

      return { ...configFile, stages: newStages };
    } else {
      // si no hay stage quiere decir que se va a agregar un nuevo estage
      const newStages = { stages: [] };
      formDataProcessed.forEach((value, index) => {
        // el index 0 es para el root del stage los demas son subStages
        const randomId = Math.random().toString(36).substring(7);
        if (index === 0) {
          newStages.id = value + randomId;
          newStages.name = value;
        } else {
          newStages.stages.push({ id: value + randomId, name: value });
        }
        return value;
      });
      configFile.stages ? configFile.stages.push(newStages) : configFile.stages = [newStages];
      return configFile;
    }
  }

  async function onSubmit (form) {
    if (form.formData) {
      const formData = form.formData;
      const config = formData && await process(Object.entries(form.formData).map(([e, i]) => i));
      await postTempConfigFile(config);
      setConfigFile({ ...config });
      setOpenNotication(true);
      handleClose(false);
    }
  }

  return (
    <Dialog
      className={classes.dialogContainer}
      fullScreen
      onClose={handleClose}
      open={open}
      TransitionComponent={Transition}
    >
      <div className={classes.container}>
        <div className={classes.topContainer}>
          {/* TOP LEFT */}
          <div className={classes.topLeft}>
            <Typography
              align='left'
              style={{
                fontFamily: 'Roboto-Regular',
                // fontWeight: '500',
                fontSize: '14px',
                color: '#161616',
                letterSpacing: '0.16px',
                lineHeight: '18px'
              }}
            >
              <div
                onClick={handleClose}
                style={{
                  cursor: 'pointer',
                  fontFamily: 'Roboto-Regular',
                  fontSize: '14px',
                  color: '#0747A6',
                  letterSpacing: '0.25px',
                  lineHeight: '20px'
                }}
              >
                {funcTranslateHelper('Viewer')}
              </div>
            </Typography>
            <Typography
              align='left'
              style={{
                paddingLeft: '1px',
                fontFamily: 'Roboto-Regular',
                color: 'rgba(0,0,0,0.87)',
                letterSpacing: '0.25px',
                fontSize: '20px'
              }}
            >
              {' '}
              {funcTranslateHelper('Builder.builder.btn.Añadir estado')}
            </Typography>
          </div>
          <div className={classes.topRight}>
            <Button
              className={classes.button}
              disabled={false}
              iconDescription='Button icon'
              kind='secondary'
              onClick={() => handleClose(false)}
              onFocus={function noRefCheck () { }}
              // renderIcon={}
              size='field'
              tabIndex={0}
              type='button'
            >
              {funcTranslateHelper('Cancelar')}
            </Button>
            <Button
              form='formCustom'
              className={classes.button}
              disabled={false}
              iconDescription='Button icon'
              kind='primary'
              onClick={onSubmit}
              onFocus={function noRefCheck () { }}
              // renderIcon={}
              size='field'
              tabIndex={0}
              type='submit'
            >
              {funcTranslateHelper('Guardar')}
            </Button>
          </div>
        </div>
        <div className='bx--grid'>
          <div className='bx--row'>
            <div className='bx--offset-lg-1 bx--col-lg-5'>
              <FormCustom formData={formData} onSubmit={onSubmit} />
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  );
}
export default NewStageForm;
